import { type Address, getAddress } from 'viem'
import { mainnet } from 'viem/chains'
import type { MatchAllCondition } from './types'

export { erc20Abi as ERC20_ABI } from 'viem'

// Amount placeholder that gets replaced by user's balance at runtime
export const AMOUNT_PLACEHOLDER =
  0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffdeadbeefn

export const tokenAddresses = {
  WETH: {
    [mainnet.id]: getAddress('0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2'),
  },
  USDC: {
    [mainnet.id]: getAddress('0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48'),
  },
  LIT: {
    [mainnet.id]: getAddress('0x232CE3bd40fCd6f80f3d55A522d03f25Df784Ee2'),
  },
  LINK: {
    [mainnet.id]: getAddress('0x514910771AF9Ca656af840dff83E8264EcF986CA'),
  },
  UNI: {
    [mainnet.id]: getAddress('0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984'),
  },
  AAVE: {
    [mainnet.id]: getAddress('0x7Fc66500c84A76Ad7e9c93437bFc5Ac33E2DDaE9'),
  },
  SKY: {
    [mainnet.id]: getAddress('0x56072C95FAA701256059aa122697B133aDEd9279'),
  },
  LDO: {
    [mainnet.id]: getAddress('0x5A98FcBEA516Cf06857215779Fd812CA3beF1B32'),
  },
  AZTEC: {
    [mainnet.id]: getAddress('0xA27EC0006e59f245217Ff08CD52A7E8b169E62D2'),
  },
} as const

export const UNWRAP_AND_CALL_ADDRESS = {
  [mainnet.id]: getAddress('0x177591f2F4DcC3a47F768f6533eC6Edf564d6927'),
} as const

export const VAULT_DEPOSITOR_ADDRESS = {
  [mainnet.id]: getAddress('0x40b72bB73B1E9380629B205e7880Fa409ae7fcc9'),
} as const

export const LIGHTER_DEPOSIT_ADDRESS = getAddress(
  '0x3b4d794a66304f130a4db8f2551b0070dfcf5ca7',
) as Address

export const MATCH_ALL_CONDITION: MatchAllCondition = '*'
